var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts",attrs:{"id":'detail_' + _vm.country}},[_c('v-chart',{ref:'detailchart_' + _vm.country,staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"init-options":_vm.initOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }